import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import { StatusCardLegacyCollapsible } from './components/StatusCardLegacyCollapsible'
import { StatusCardLegacyContext } from './StatusCardLegacyContext'
import { StatusCardLegacyContent } from './styles/StatusCardLegacyContentStyled'
import { StatusCardLegacyLeftStyled } from './styles/StatusCardLegacyLeftStyled'
import { StatusCardLegacyRightStyled } from './styles/StatusCardLegacyRightStyled'
import { StatusCardLegacyStyled } from './styles/StatusCardLegacyStyled'

export interface IStatusCardLegacyProps {}

export const StatusCardLegacy = ({
  children,
}: PropsWithChildren<IStatusCardLegacyProps>) => {
  const [showCollapsible, setShowCollapsible] = useState(false)

  return (
    <StatusCardLegacyStyled>
      <StatusCardLegacyContext.Provider
        value={{
          showCollapsible,
          setShowCollapsible,
        }}
      >
        <div className='status-card-container'>{children}</div>
      </StatusCardLegacyContext.Provider>
    </StatusCardLegacyStyled>
  )
}

StatusCardLegacy.Left = StatusCardLegacyLeftStyled
StatusCardLegacy.Right = StatusCardLegacyRightStyled
StatusCardLegacy.Collapsible = StatusCardLegacyCollapsible
StatusCardLegacy.Content = StatusCardLegacyContent

StatusCardLegacy.displayName = 'StatusCardLegacy'
